import { CmsCardForm } from './cms-card-form.interface';
import { CmsProtectionStartSummaryPanelBoilers } from './cms-protection-start-summary-panel-boilers.interface';
import { CmsProtectionStartSummaryPanelWhiteGoods } from './cms-protection-start-summary-panel-white-goods.interface';

export interface CmsCardPage
  extends CmsCardForm,
    CmsProtectionStartSummaryPanelBoilers,
    CmsProtectionStartSummaryPanelWhiteGoods {
  pageTitle: string;
}
